import { render, staticRenderFns } from "./RegistrationNavbar.vue?vue&type=template&id=e20cef88&scoped=true&"
import script from "./RegistrationNavbar.vue?vue&type=script&lang=js&"
export * from "./RegistrationNavbar.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNavbar.vue?vue&type=style&index=0&id=e20cef88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20cef88",
  null
  
)

export default component.exports